var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saved-indicator"},[_c('p',{staticClass:"saved-indicator__text",class:{ 'saved-indicator__text--saved': _vm.saved }},[_c('small',[_vm._v("Changes saved")])])])}
var staticRenderFns = []

export { render, staticRenderFns }